const esFields = require('../../../resources/esFields.json');
let sourceFields = {};
Object.keys(esFields).forEach((key)=>{
  // note that fields with no label will be hidden in the 'detailed metadata' UI -- todo: use 'display' param instead
  sourceFields[key] = esFields[key].label
})

const fields = {
  sourceFields: sourceFields,

  // result fields specify fields that appear in search results. if this doesn't exist, result Fields will default to sourceFields
  resultFields: {
    'topic.value': 'Topic',
    'type.value':'Type',
    'category.value':'Category'
  },

  facetFields : [
    {
      field: 'topic.value',
      label: 'Topics',
      type: 'term',
    },
    {
      field: 'affiliation.value',
      label: 'Affiliations',
      type: 'term',
    },
    {
      field: 'sort_date',
      label: 'Date',
      type: 'range',
      date_format: 'yyyy',
      interval: 'year'
    },
    {
      field: 'contributor',
      label: 'Contributors',
      type: 'term',
    },
    {
      field: 'genre.value',
      label: 'Genres',
      type: 'term',
    },
    {
      field: 'category.value',
      label: 'Categories',
      type: 'term',
    },
    {
      field: 'type.value',
      label: 'Types',
      type: 'term',
    },
    {
      field: 'access.type',
      label: '',
      type: 'hidden',
    },
  ],
}

const searchOpts = {
  defaultIndex: app_default_index,
  searchScope: false,
  queryPrompt: "Enter a query to search the Research Access Portal Collection",
  facetLimitLabel: "Limit results to:",
  sortResults: [
    {
      value: "_score",
      label: "Sort by Relevance"
    },
    {
      value: "title.raw,asc",
      label: "Sort by Title A-Z"
    },
    {
      value: "title.raw,desc",
      label: "Sort by Title Z-A"
    },
    {
      value: "sort_date,asc",
      label: "Sort oldest to newest"
    },
    {
      value: "sort_date,desc",
      label: "Sort newest to oldest"
    }
  ],
  pageSizes: [20, 40, 80]
}

export { fields, searchOpts };
